(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoDetailController', AlumnoUadyMatriculadoDetailController);

    AlumnoUadyMatriculadoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoDetailController($scope, $rootScope, $stateParams, previousState, entity, AlumnoUadyMatriculado) {
        var vm = this;

        vm.alumnoUadyMatriculado = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:alumnoUadyMatriculadoUpdate', function(event, result) {
            vm.alumnoUadyMatriculado = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
